import useAuthorizationStore from './UseAuthorizationStore';
var useActiveSubjectId = function () { var _a; return (_a = useAuthorizationStore()) === null || _a === void 0 ? void 0 : _a.activeSubjectId; };
export default useActiveSubjectId;
//# sourceMappingURL=UseActiveSubjectId.js.map